<script setup lang="ts">
const { theme } = useTheme()
</script>

<template>
  <div :class="footerVariants.author({ theme })">
    <IconsLogoAschehoug aria-hidden="true" />
    <IconsLogoUniversitetsforlaget aria-hidden="true" />
    <span>©&nbsp;<NuxtTime :datetime="Date.now()" year="numeric" /> Juridika</span>
  </div>
</template>
